<template>
  <div class="mapcontainer">
    <div id="box">
      <div id="map"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import 'echarts-gl'

export default {
  name: 'ThreeDMapView',
  data() {
    return {
      chart: null,
      currentLang: 'CN',
      i18n: {
        CN: {
          home: '首页',
          about: '关于同升',
          services: '产品与服务',
          news: '公司动态',
          contact: '联系我们',
          scatterNames: {
            '中亚': '中亚',
            '俄罗斯': '俄罗斯',
            '北美': '北美',
            '北欧': '北欧'
          }
        },
        EN: {
          home: 'HOME',
          about: 'ABOUT US',
          services: 'PRODUCT AND SERVICE',
          news: 'NEWS',
          contact: 'CONTACT US',
          scatterNames: {
            '中亚': 'Central Asia',
            '俄罗斯': 'Russia',
            '北美': 'North America',
            '北欧': 'Northern Europe'
          }
        },
        RU: {
          home: 'Главная страница',
          about: 'О компании Tongsheng',
          services: 'Продукция и услуги',
          news: 'Новости компании',
          contact: 'Свяжитесь с нами',
          scatterNames: {
            '中亚': 'Центральная Азия',
            '俄罗斯': 'Россия',
            '北美': 'Северная Америка',
            '北欧': 'Северная Европа'
          }
        }
      }
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768
    },
    scatterData() {
      const names = this.i18n[this.currentLang].scatterNames
      return [
        {
          name: names['中亚'],
          value: [71.5, 42.5, 0]
        },
        {
          name: names['俄罗斯'],
          value: [105.3, 61.5, 0]
        },
        {
          name: names['北美'],
          value: [-100.0, 45.0, 0]
        },
        {
          name: names['北欧'],
          value: [15.0, 65.0, 0]
        }
      ]
    }
  },
  mounted() {
    this.initChart()
  },
  created () {
    const saved = localStorage.getItem('lang')
    if (saved) this.currentLang = saved
    window.addEventListener('languageChanged', this.handleLangChange)
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
    window.removeEventListener('languageChanged', this.handleLangChange)
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
  },
  methods: {
    initChart() {
      const dom = document.getElementById('map')
      this.chart = echarts.init(dom)
      const option = {
        backgroundColor: '#1a1a1a',
        globe: {
          show: true,
          // baseTexture: 'https://img.isqqw.com/profile/upload/2024/11/12/ad005ff4-0851-4d13-a36e-cdd9f5382d3b.jpg',
          // baseTexture: '/imgs/home/images/3ddiqiu2.png',
          baseTexture: 'https://oss.echinahealth.cn/3ddiqiu2.png',
          shading: 'color',
          environment: '#edf0f7',
          postEffect: {
            enable: false
          },
          light: {
            main: {
              intensity: 1
            },
            ambient: {
              intensity: 0.8
            }
          },
          viewControl: {
            autoRotate: true,
            autoRotateSpeed: 1,
            distance: this.isMobile ? 150 : 200,
            minDistance: 50,
            maxDistance: 400,
            rotateSensitivity: 1,
            zoomSensitivity: 1
          }
        },
        series: [{
          type: 'scatter3D',
          coordinateSystem: 'globe',
          zlevel: 30,
          depthTest: false,
          symbol: 'circle',
          symbolSize: this.isMobile ? 12 : 16,
          itemStyle: {
            color: '#336fff',
            borderColor: '#fff',
            borderWidth: 5
          },
          label: {
            show: true,
            formatter: '{b}',
            position: 'top',
            zlevel: 31,
            textStyle: {
              color: '#fff',
              fontSize: this.isMobile ? 12 : 16,
              // fontWeight: 'bold',
              backgroundColor: '#336fff',
              borderRadius:25,
              padding: [6,20],
              distance: 0
            }
          },
          emphasis: {
            itemStyle: {
              color: '#ffd93d'
            },
            label: {
              show: true,
              formatter: '{b}',
              position: 'top',
              zlevel: 31,
              textStyle: {
                color: '#fff',
                fontSize: this.isMobile ? 12 : 16,
                backgroundColor: '#336fff',
                borderRadius: 25,
                padding: [6, 20],
                distance: 0
              }
            }
          },
          data: this.scatterData
        }]
      }

      this.chart.setOption(option)
      window.addEventListener('resize', this.handleResize)
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    },
    handleLangChange(event) {
      this.currentLang = event.detail.lang
      if (this.chart) {
        const option = this.chart.getOption()
        option.series[0].data = this.scatterData
        this.chart.setOption(option)
      }
    }
  }
}
</script>

<style scoped>
.mapcontainer {
  max-width: 100vw;
  max-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

#box {
  width: 100%;
  aspect-ratio: 1 / 1;
  width: 740px;
  height: 740px;
}

#map {
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  #box {
    max-width: 90vw;
    max-height: 90vw;
  }
}
</style>